import { AtributosService } from './../../../../company-view/services/atributos.service';
import { EmpresaTreeViewService } from './../../../../employee/services/empresa-treeView.service';
import { MatTableDataSource } from '@angular/material/table';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { TaskSaveService } from 'app/modules/task/services/task-save.service';
import { AddTimeComponent } from 'app/modules/task/components/add-time/add-time.component';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';
import { SharedService } from 'app/modules/common/services/shared-service';

@Component({
    selector: 'app-tarea-list',
    templateUrl: './tarea-list.component.html',
    styleUrls: ['./tarea-list.component.scss'],
    standalone: false
})
export class TareaListComponent implements OnInit {
    public displayedColumns: any[];
    public selectedRowIndex = 0;
    public searchList =new MatTableDataSource<any>();
    public isFirstTime:boolean=true;
    attributeList=[];

    constructor(
        public selectionService: SelectionGenericService,
        public taskService: TaskSaveService,
        public dialog: MatDialog,
        public fileExportService: FileExportService,
        public sharedService: SharedService,
        public empresaTreeViewService: EmpresaTreeViewService,
        private changeDetect: ChangeDetectorRef,
        private _atributosService: AtributosService,
    ) {
        this.searchList=this.selectionService.dataSource;
        this.empresaTreeViewService.EmpId.subscribe((_res: any) => {
            if (_res > 0) {
             
                this.isFirstTime=true;
                this.loadAttributes(_res)
            }
        }); 
    }
    
    loadAttributes(empresaId)
    {
        this._atributosService.GetAttributoEmpresa(empresaId)
        .subscribe(res => {
        if (res.result) {
            this.attributeList=res.result;
            this.refreshDisplayColumns();
            // this.dataSourceHeaderAtributos = res.result;
            // this.loadValoresActuales(1, res.result[0].attributoName, 1)
            
        }
        });
    }
    ngAfterViewInit(): void {
        this.isFirstTime=true;
        this.changeDetect.detectChanges();
      }

    ngOnInit(): void {
        this.loadAttributes(parseInt(localStorage.getItem('Empresa')))
        this.taskService.setPermissionForContextMenu();
        this.selectionService.displayedColumns = [
            'action',
            'fecha',
            'hora',
            'empresa',
            'trabajador',
            'tarea',
        ];
        this.loadCachedSearch(); 
    }
    refreshDisplayColumns()
    {
        this.displayedColumns = [
            {
                name: 'Actions',
                column: 'action',
                show: true,
                isPermit: true,
                disabled: true,
            },
            {
                name: 'Marcas',
                column: 'marcas',
                show: true,
                isPermit: true,
                disabled: true,
            },
            {
                name: 'Empresa',
                column: 'empresa',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Proyecto',
                column: 'proyecto',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 1',
                column: 'nivel1',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 2',
                column: 'nivel2',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 3',
                column: 'nivel3',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 4',
                column: 'nivel4',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 5',
                column: 'nivel5',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'NIF',
                column: 'enif',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Ref. Trabajador',
                column: 'referencia',
                show: false,
                isPermit: true,
                disabled: false,
            },

            {
                name: 'Referencia de Baja',
                column: 'leaveRef',
                show: false,
                isPermit: true,
                disabled: false,
            },
           
            {
                name: 'Trabajador',
                column: 'trabajador',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'F. Fin Contrato',
                column: 'fFinContrato',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Prioritaria',
                column: 'prioritaria',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Tipo B.',
                column: 'tipoB',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'F. Baja',
                column: 'fBaja',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Médico',
                column: 'nomMedico',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'NJ',
                column: 'nj',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Fecha NJ',
                column: 'fechaNj',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Días NJ',
                column: 'diasNj',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'FPA',
                column: 'fpa',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Días previstos',
                column: 'diasPrevistos',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Diagnóstico',
                column: 'diagnostico',
                show: false,
                isPermit:
                    this.selectionService.selectionPermissions.HasDiagnosisMark,
                disabled: false,
            },
            {
                name: 'Teléfonos',
                column: 'phones',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Dirección',
                column: 'direccion',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Población',
                column: 'poblacion',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'CP',
                column: 'cp',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Provincia',
                column: 'provincia',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Consentimiento',
                column: 'consentimiento',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'F.Consentimiento',
                column: 'fConsentimiento',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Atributos',
                column: 'atributos',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[0].attributoName,
                column: 'tAttr1',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[1].attributoName,
                column: 'tAttr2',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[2].attributoName,
                column: 'tAttr3',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[3].attributoName,
                column: 'tAttr4',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[4].attributoName,
                column: 'tAttr5',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[5].attributoName,
                column: 'tAttr6',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[6].attributoName,
                column: 'tAttr7',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[7].attributoName,
                column: 'tAttr8',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[8].attributoName,
                column: 'tAttr9',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[9].attributoName,
                column: 'tAttr10',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[10].attributoName,
                column: 'tAttr11',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[11].attributoName,
                column: 'tAttr12',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Fecha',
                column: 'fecha',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Hora',
                column: 'hora',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Tarea',
                column: 'tarea',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Autor',
                column: 'autor',
                show: true,
                isPermit: true,
                disabled:
                    this.selectionService.selectionPermissions.HasPermisos510,
            },
            {
                name: 'Comentario',
                column: 'comentario',
                show: false,
                isPermit: true,
                disabled:
                    this.selectionService.selectionPermissions
                        .HasTereaSelectionComentario,
            },
            {
                name: 'F. Registro',
                column: 'fRegistro',
                show: false,
                isPermit:true,
                disabled: false,
            },
            {
                name: 'Usuario',
                column: 'usuario',
                show: false,
                isPermit:true,
                disabled: false,
            },
            {
                name: 'F. Envío',
                column: 'fEnvio',
                show: false,
                isPermit: this.selectionService.selectionPermissions.HasTereaEnvio,
                disabled: false,
            },
            {
                name: 'Realizada',
                column: 'realizada',
                show: false,
                isPermit: this.selectionService.selectionPermissions.HasTereaRealizada,
                disabled: false,
            },
            {
                name: 'F. Últ. Reclamación',
                column: 'fReclamacion',
                show: false,
                isPermit: this.selectionService.selectionPermissions.HasTereaFReclamacion,
                disabled: false,
            },
            {
                name: 'Nº Tels',
                column: 'reclTelefonica',
                show: false,
                isPermit: this.selectionService.selectionPermissions.HasTereaReclTelefonica,
                disabled: false,
            },
            {
                name: 'Nº Emails',
                column: 'reclUSuario',
                show: false,
                isPermit: this.selectionService.selectionPermissions.HasTereaReclUSuario,
                disabled: false,
            },
            {
                name: 'Observaciones',
                column: 'reclObs',
                show: false,
                isPermit: this.selectionService.selectionPermissions.HasTereaReclObs,
                disabled: false,
            },
            
            // fConsentimiento
        ];

        this.taskService.tasksColumns=[];
        this.displayedColumns.forEach(element => {
            if(element.show && element.isPermit) {
                this.taskService.tasksColumns.push(element.name)
            }
        });
    }
    checkConsentimento(TipoConsentimiento,Consentimiento)
    {
        if (TipoConsentimiento == 'EG')
        {
            return 'EG';
        }
        else if(TipoConsentimiento=='G')
        {
            return 'G'
        }
        else if(Consentimiento=='E')
        {
            return 'E'
        }
        else if(Consentimiento=='S' || TipoConsentimiento=='E')
        {
            return 'F'
        }else
        {
            return 'N'
        }
    }

    toggleDisplayColumn(columnName, value): any {
        this.displayedColumns.filter((c) => c.column === columnName)[0].show =
            value;
        this.taskService.tasksColumns=[];
        this.displayedColumns.forEach(element => {
            if(element.show) {
                this.taskService.tasksColumns.push(element.name)
            }
        });
    }

    getDisplayedColumns(): string[] {
      this.taskService.tasksColumns = this.displayedColumns
      .filter((cd) => cd.show && cd.isPermit)
      .map((cd) => cd.name);

        return this.displayedColumns
            .filter((cd) => cd.show && cd.isPermit)
            .map((cd) => cd.column);
    }

    loadCachedSearch(): void {
        const searchConfig = this.selectionService.getCache();
        if (searchConfig) {
            this.selectionService.dataSource.data = searchConfig.taskSelection;
            this.selectionService.FromDate = searchConfig.fromDate;
            this.selectionService.ToDate = searchConfig.toDate;
            this.selectionService.loggedDoctorName = searchConfig.doctor;
        }
    }

    pedirCita(trabajadorId, bajaId: number) :void {
        this.taskService.GoToPedirCita(trabajadorId, bajaId);
    }

    GoToEmployee(trabajadorId): void {
        this.taskService.GoToEmployee(trabajadorId);
    }

    PrintDocument(task): any {
        this.taskService.PrintDocument(task);
    }

    PrintCartaLopd(task): any {
        this.taskService.OnPrintLOPDDocument(task);
    }

    public getTasks(pageEvent: PageEvent): void {
        this.selectionService.SearchTasks(
            pageEvent.pageIndex,
            pageEvent.pageSize,
            false
        );
    }

    changeTimePopup(task): any {
        const dialogRef = this.dialog.open(AddTimeComponent, {
            width: '',
            data: task,
        });

        dialogRef.componentInstance.taskService.savedTaskSelection.subscribe(
            () => {
                this.selectionService.SearchTasks(0, 10, false);
            }
        );
    }

    deleteTask(task): void {
        const isMarkedTask = task.tipo
            ? this.taskService.validateMarkedTask(task.tipo)
            : false;
        if (isMarkedTask) {
            this.callDeleteTask(task);
        } else {
            this.openConfirmDialogForDelete(task);
        }
    }
    openConfirmDialogForDelete(task): void {
        const message = `¿Eliminar definitivamente esta tarea?`;
        const dialogData = new ConfirmDialogModel('Confirmar acción', message);
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData,
        });
        dialogRef.afterClosed().subscribe((responce) => {
            if (responce) {
                this.callDeleteTask(task);
            }
        });
    }

    callDeleteTask(task: any): any {
        this.taskService.deleteTask(task.tareaId).subscribe(
            (res) => {
                if (res.code === 0) {
                    this.selectionService.ShowSnackBar(
                        'Borrado exitosamente',
                        '',
                        2500
                    );
                    this.selectionService.SearchTasks(
                        this.selectionService.taskResultModal.PageIndex,
                        this.selectionService.taskResultModal.PageSize,
                        false
                    );
                } else {
                    this.selectionService.ShowSnackBar(
                        'eliminar falla',
                        '',
                        2500
                    );
                }
            },
            (err) => {
                this.selectionService.ShowSnackBar('eliminar falla', '', 2500);
            }
        );
    }

    OnToDateClear(): void {
        this.selectionService.ToDate = null;
    }

    OnFromDateClear(): void {
        this.selectionService.FromDate = null;
    }

    getLeaveRecord(row, event): any {
        const isExcept = event.target.classList.contains('except');
        if (!isExcept && this.selectionService.isShowLeavePanel) {
            this.selectedRowIndex = row.tareaId;
            this.selectionService.getLeaveRecord(row);
        }
    }

    public DownloadExcel(): any {
        if (this.selectionService.dataSource.data.length > 0) {
            this.fileExportService.exportDatasetToExcel(
                this.selectionService.dataSource.data,
                'Tareas-Selección'
            );
        } else {
            this.sharedService.ShowSnackBar(
                'La lista esta vacía',
                'Okay',
                2000
            );
        }
    }
}
